module.exports = __webpack_public_path__ + "img/hr-wooden-particle-10.71065ed6.png";